import { TWasmBaseMaps } from "~/interfaces";
import { decOpacityToHex, getGeometryStyleHash } from "./utils";

export const LAYER_MAPPING: {[key in TWasmBaseMaps]: string } = {
	"zakladni": "web_a_base",
	"turisticka": "web_b_tourist",
	"zimni": "web_c_winter",
	"letecka": "web_d_ophoto",
	"dopravni": "web_e_traffic",
	"zemepisna": "web_f_geography",
	"19stoleti": "web_g_19century",
};

export const OPHOTO_YEAR_SRC_MAPPING: Record<string, string> = {
	/* eslint-disable quote-props */
	"2021": "ophoto1921",
	"2018": "ophoto1618-m",
	"2015": "ophoto1415-m",
	"2012": "ophoto1012-m",
	"2006": "ophoto0406-m",
	"2003": "ophoto0203-m",
	/* eslint-enable quote-props */
};

export const TEXTURES_NAMES = {
	main: "main-texture",
	custom: "custom-texture",
};

export const WASM_TEXTURES = {
	mainTexture: "/img/wasm-textures.png",
	defSize: 100,
	textLineHeight: 30,
	ratio: 2,
	searchMarkersWidth: 125,
};

const keepExactWidth = true;

export const DEF_LINE_STYLES = {
	DEFAULT: getGeometryStyleHash({
		color: "#1eae00",
		width: 8,
		keepExactWidth,
		lineCap: "square",
	}),
	MEASURE_LINE_ACTIVE: getGeometryStyleHash({
		color: "#ff0000",
		width: 8,
		keepExactWidth,
		lineCap: "square",
	}),
	MEASURE_LINE_DEACTIVE: getGeometryStyleHash({
		color: "#6b7580",
		width: 8,
		keepExactWidth,
		lineCap: "square",
	}),
	MEASURE_CURRENT_ACTIVE: getGeometryStyleHash({
		color: "#ff0000",
		width: 8,
		keepExactWidth,
		dashed: "20",
	}),
	MEASURE_CURRENT_DEACTIVE: getGeometryStyleHash({
		color: "#6b7580",
		width: 8,
		keepExactWidth,
		dashed: "20",
	}),
	BACKPACK_PATH_ACTIVE: getGeometryStyleHash({
		// stroke opacity 0.65 -> (0.65*255 >>> 0).toString(16) = a5
		color: `#ff0000${decOpacityToHex(0.65)}`,
		width: 6,
		edgeColor: "#ffffff",
		edgeWidth: 1,
		keepExactWidth,
	}),
	BACKPACK_PATH_DEACTIVE: getGeometryStyleHash({
		color: `#6b7580`,
		width: 6,
		edgeColor: "#ffffff",
		edgeWidth: 1,
		keepExactWidth,
	}),
	ACTIVITY_DETAIL: getGeometryStyleHash({
		color: `#ff0000${decOpacityToHex(0.65)}`,
		width: 12,
		keepExactWidth,
	}),
	POI_DETAIL_GEOM: getGeometryStyleHash({
		color: `#ff0000`,
		width: 6,
		edgeColor: "#ffffff",
		edgeWidth: 4,
		keepExactWidth,
	}),
};

// 0 nejnizsi priorita
export const WASM_GEOMETRIES_ZINDEX = {
	// route - aktivni
	routeRoutesActive: 10,
	// route - neaktivni
	routeRoutesDeactive: 5,
	// route - dopravni dostupnost
	routeTraffic: 15,
};
